/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Footer_OfficialInputs */

const en_fc_footer_official = /** @type {(inputs: Fc_Footer_OfficialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Official FilmCraft`)
};

/**
* | output |
* | --- |
* | "Official FilmCraft" |
*
* @param {Fc_Footer_OfficialInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_footer_official = /** @type {((inputs?: Fc_Footer_OfficialInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Footer_OfficialInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_footer_official(inputs)
});
export { fc_footer_official as "fc.footer.official" }